"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Zone = void 0;
/*
 * Copyright 2023, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const MapObject_1 = require("../../utils/objects/MapObject");
/**
 * A zone is a polygon or multipolygon object on the map
 *
 * @export
 * @class Zone
 * @extends {MapObject<GeoJSON.Polygon | GeoJSON.MultiPolygon, ZoneAttributes>}
 */
class Zone extends MapObject_1.MapObject {
    constructor(attributes = {}, isNew) {
        super(attributes, isNew, undefined);
    }
    toString() {
        return this.attributes.name || this.attributes.shortname || this.getId();
    }
    get collectionManager() {
        // TODO: test or use dependency injection
        return this._collectionManager;
    }
    static getPluralName() {
        return 'zones';
    }
    static getCapitalizedPluralName() {
        return 'Zones';
    }
    static getDisplayName() {
        return Zone.displayName;
    }
}
exports.Zone = Zone;
Zone.displayName = 'Zone';
exports.default = Zone;
//# sourceMappingURL=Zone.js.map